import actions from './actions';

const {
  PAYPAL_INVITATION_BEGIN,
  PAYPAL_INVITATION_SUCCESS,
  PAYPAL_INVITATION_ERR,
  PAYPAL_DISCONNECT_BEGIN,
  PAYPAL_DISCONNECT_SUCCESS,
  PAYPAL_DISCONNECT_ERR,
  PAYPAL_GET_CARDS_BEGIN,
  PAYPAL_GET_CARDS_SUCCESS,
  PAYPAL_GET_CARDS_ERR,
  PAYPAL_GET_SETUP_TOKEN_BEGIN,
  PAYPAL_GET_SETUP_TOKEN_SUCCESS,
  PAYPAL_GET_SETUP_TOKEN_ERR,
  PAYPAL_EXCHANGE_TOKEN_BEGIN,
  PAYPAL_EXCHANGE_TOKEN_SUCCESS,
  PAYPAL_EXCHANGE_TOKEN_ERR,
  PAYPAL_DELETE_CARD_BEGIN,
  PAYPAL_DELETE_CARD_SUCCESS,
  PAYPAL_DELETE_CARD_ERR,
  PAYPAL_SET_DEFAULT_CARD_BEGIN,
  PAYPAL_SET_DEFAULT_CARD_SUCCESS,
  PAYPAL_SET_DEFAULT_CARD_ERR,
} = actions;

const initState = {
  list: null,
  loading: false,
  error: null,
};

/**
 *
 * @todo impure state mutation/explaination
 */
const PaypalReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case PAYPAL_INVITATION_BEGIN:
    case PAYPAL_DISCONNECT_BEGIN:
    case PAYPAL_GET_CARDS_BEGIN:
    case PAYPAL_GET_SETUP_TOKEN_BEGIN:
    case PAYPAL_EXCHANGE_TOKEN_BEGIN:
    case PAYPAL_DELETE_CARD_BEGIN:
    case PAYPAL_SET_DEFAULT_CARD_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case PAYPAL_INVITATION_SUCCESS:
    case PAYPAL_DISCONNECT_SUCCESS:
    case PAYPAL_GET_CARDS_SUCCESS:
    case PAYPAL_GET_SETUP_TOKEN_SUCCESS:
    case PAYPAL_EXCHANGE_TOKEN_SUCCESS:
    case PAYPAL_DELETE_CARD_SUCCESS:
    case PAYPAL_SET_DEFAULT_CARD_SUCCESS:
      return {
        ...state,
        list: data,
        loading: false,
      };
    case PAYPAL_INVITATION_ERR:
    case PAYPAL_DISCONNECT_ERR:
    case PAYPAL_GET_CARDS_ERR:
    case PAYPAL_GET_SETUP_TOKEN_ERR:
    case PAYPAL_EXCHANGE_TOKEN_ERR:
    case PAYPAL_DELETE_CARD_ERR:
    case PAYPAL_SET_DEFAULT_CARD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default PaypalReducer;
